const policyHeroSection = $('#hero-section');

const addPolicyHeroIn = () => {
  const heroDescription = policyHeroSection.find('.hero-descriptor');
  const heroTitle = policyHeroSection.find('.hero-title');
  const menuParent = $('.list-float-menu');
  const listParent = $('.list-parent');
  const navParent = $('.hero-nav-buttons-parent');

  const heroTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
    },
  });

  heroTL.addLabel('step1');
  heroTL.add(addBigTitleAnimation(heroTitle, 150, 0.9, 0.15).play(), 'step1+=0.6');
  heroTL.add(addElementInAnimation(heroDescription, '1000%', 0.9, 0).play(), 'step1+=0.5');
  heroTL.add(addElementInAnimation(navParent, '12.5vw', 0.9, 0).play(), 'step1+=0.7');
  heroTL.add(addElementInAnimation(menuParent, '12.5vw', 0.9, 0).play(), 'step1+=0.8');
  heroTL.add(addElementInAnimation(listParent, '12.5vw', 0.9, 0).play(), 'step1+=0.9');
  //heroTL.add(addBtnAnimation(heroBtn).play(), 'step1+=1.5');
  heroTL.add(headerAnimation(true, 0.6, 0.01).play(), 'step1+=2.13');

  return heroTL;
};

$(window).on('load', () => {
  const [nav] = performance.getEntriesByType('navigation');
  const policyHeroTL = addPolicyHeroIn();
  pageIn(policyHeroTL, nav);
});
